export default {
  name: 'paymentRecord',
  data () {
    return {
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      totalRows: 100,
      tooltip: true,
      labelPosition: 'right',
      formInline: {
        system: [],
        sysId: '',
        virtualSellerCode: '',
        payChannelCode: '',
        sellerTradeNo: '',
        tradeNo: '',
        payTime: '',
        payStatus: ''
      },
      sysData: [],
      merchantData: [],
      payChannelData: [],
      tableList: [],
      dialogFormVisible: false,
      payDetailForm: []
    }
  },
  created () {
    this.querySearchSel()
    this.queryList()
  },
  methods: {
    /* 表格状态值转换 */
    payStatus (row) {
      if (row.payStatus == '0') {
        return '等待支付'
      } else if (row.payStatus == '1') {
        return '支付成功'
      } else if (row.payStatus == '2') {
        return '支付失败'
      } else if (row.payStatus == '3') {
        return '取消支付'
      } else {
        return ''
      }
    },
    downBill () { // 账单下载
      let op = {}
      op.payStartTime = this.formInline.payTime ? this.formInline.payTime[0] : ''
      op.payEndTime = this.formInline.payTime ? this.formInline.payTime[1] : ''
      op.virtualSellerCode = this.formInline.virtualSellerCode
      let id = this.formInline.sysId + ''
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.sysIds = sysIds
      op.payChannelCode = this.formInline.payChannelCode
      op.sellerTradeNo = this.formInline.sellerTradeNo
      op.tradeNo = this.formInline.tradeNo
      op.payStatus = this.formInline.payStatus
      if (!sysIds.length) {
        this.$message.error('请选择订单所属系统')
        return
      }
      if (!op.payChannelCode) {
        this.$message.error('请选择支付渠道')
        return
      }
      if (!op.payStartTime) {
        this.$message.error('请选择支付时间')
        return
      }
      if (!op.payEndTime) {
        this.$message.error('请选择支付时间')
        return
      }
      let url = this.$API.billmanagement.downloadPayRecord
      // let url = 'http://172.16.9.104:5010/agw/payCtr/downloadPayRecord'
      if (op.payStartTime && op.payEndTime  && op.payChannelCode) {
        let params = { // 参数
          payChannelCode: op.payChannelCode,
          sysIds: op.sysIds,
          virtualSellerCode: op.virtualSellerCode,
          sellerTradeNo: op.sellerTradeNo,
          tradeNo: op.tradeNo,
          payStatus: op.payStatus,
          payStartTime: op.payStartTime,
          payEndTime: op.payEndTime,
          mtk: localStorage.getItem('usermtk')
        }
        console.log(params)
        // this.$axios({
        //   url: url,
        //   method: 'post',
        //   data: params
        // }).then((response) => {
        //   // _this.query()
        //   this.$message.success('生成核算单成功！')
        // }).catch((err) => {
        //   console.log(err)
        // })
        let form = document.createElement('form')
        form.id = 'form'
        form.name = 'form'
        document.body.appendChild(form)
        for (let obj in params) {
          if (params.hasOwnProperty(obj)) {
            var input = document.createElement('input')
            input.tpye = 'hidden'
            input.name = obj
            input.value = params[obj]
            form.appendChild(input)
          }
        }
        form.method = 'POST' // 请求方式
        form.action = url
        form.submit()
        document.body.removeChild(form)
        return false
      }
    },
    /* 弹窗状态值转换 */
    payStatusToText (type) {
      switch (parseInt(type)) {
        case 0:
          type = '等待支付'
          break
        case 1:
          type = '支付成功'
          break
        case 2:
          type = '支付失败'
          break
        case 3:
          type = '取消支付'
          break
        default:
          type = ''
      }
      return type
    },
    querySearchSel () {
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      let _self = this
      /* 查询所属系统列表 */
      this.$axios
        .post(this.$API.apiList.querySysList, params)
        .then(function (r) {
          _self.sysData = r.data.resData
        })
        .catch(function (error) {})
      /* 查询商户名称列表 */
      this.$axios
        .get(this.$API.pay.queryVirtualSellerList, {})
        .then(function (r) {
          _self.merchantData = r.data.resData.sellerList
        })
        .catch(function (error) {})
      /* 查询支付渠道列表 */
      this.$axios
        .get(this.$API.pay.queryPayChannelList, {})
        .then(function (r) {
          _self.payChannelData = r.data.resData.channelList
        })
        .catch(function (error) {})
    },
    queryList () {
      /* 查询列表 */
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.sizeSmall,
        payChannelCode: this.formInline.payChannelCode,
        payEndTime: this.formInline.payTime ? this.formInline.payTime[1] : '',
        payStartTime: this.formInline.payTime ? this.formInline.payTime[0] : '',
        sellerTradeNo: this.formInline.sellerTradeNo.trim(),
        sysIds: sysIds,
        tradeNo: this.formInline.tradeNo.trim(),
        virtualSellerCode: this.formInline.virtualSellerCode,
        payStatus: this.formInline.payStatus
      }
      let _self = this
      this.$axios
        .post(this.$API.pay.queryPayRecordListByPage, params)
        .then(function (r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 点击查询按钮 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 重置操作 */
    onReset (formName) {
      // console.log(this.formInline)
      this.formInline.sysId = ''
      this.formInline.virtualSellerCode = ''
      this.formInline.payStatus = ''
      this.formInline.payChannelCode = ''
      this.formInline.sellerTradeNo = ''
      this.formInline.tradeNo = ''
      this.formInline.payTime = ''
      this.formInline = Object.assign({}, this.formInline)
      // this.$refs[formName].resetFields()
    },
    /* 查看详情 */
    showDetail (data) {
      this.dialogFormVisible = true
      let _self = this
      let params = {
        outTradeNo: data.outTradeNo
      }
      this.$axios
        .get(this.$API.pay.queryPayRecordById, { params: params })
        .then(function (r) {
          _self.payDetailForm = r.data.resData
        })
        .catch(function (error) {})
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.sizeSmall = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/pay/paymentRecord.js